export default function Load(){
    return <div id="preloader"></div>
}